//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';
import { PackageMinutesDisplayItem } from './PackageMinutesDisplayItem';

export class PackageSummaryDisplayItem extends ItemBase {
    TeacherID: string | null = null;
    StudentID: string | null = null;
    Teacher: TeacherNameDisplayItem | null = null;
    Student: StudentNameDisplayItem | null = null;
    NextExpiryDate: string | null = null;
    TotalMinutesUnused: number = 0;
    TotalMinutesBooked: number = 0;
    TotalMinutes: number = 0;
    Active: boolean = false;
    LastPurchase: PackageMinutesDisplayItem | null = null;
    LessonDuration: number = 0;

    constructor(initializer?: Partial<PackageSummaryDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "PackageSummaryDisplayItem";
}
